import { alpha } from '@mui/material';
import { ColorsV2 } from './color';

const Buttons = {
  textMedium: {
    height: '2.625rem',
    width: '9rem',
    fontSize: '1rem',
  },
  baseStyle: {
    iconButton: {
      width: '2.625rem',
      height: '2.625rem',
      color: ColorsV2.acent,
      '&.Mui-checked': {
        color: ColorsV2.white,
      },
      '&:hover': {
        color: ColorsV2.white,
        bgcolor: ColorsV2.acent,
      },
    },
    primaryButton: {
      boxShadow: 1,
      backgroundColor: ColorsV2.primary,
      color: ColorsV2.acent,
      '&:hover': {
        color: ColorsV2.white,
        backgroundColor: ColorsV2.acent,
      },
      '&:disabled': {
        color: '#808080',
        backgroundColor: ColorsV2.primary,
      },
    },
    primaryButtonHighPriority: {
      boxShadow: 1,
      backgroundColor: ColorsV2.acent,
      border: '2px solid ' + ColorsV2.acent,
      color: ColorsV2.white,

      '&:hover': {
        backgroundColor: ColorsV2.primary,
        color: ColorsV2.acent,
      },
      '&:disabled': {
        color: '#808080',
        backgroundColor: ColorsV2.primary,
        border: '2px solid #808080',
      },
    },
    primaryButtonLowPriority: {
      boxShadow: 1,
      backgroundColor: ColorsV2.primary,
      border: '2px solid ' + ColorsV2.outline,
      color: ColorsV2.white,

      '&:hover': {
        backgroundColor: ColorsV2.primary,
        border: '2px solid ' + ColorsV2.acent,
        color: ColorsV2.acent,
      },
      '&:disabled': {
        color: '#808080',
        backgroundColor: ColorsV2.primary,
        border: '2px solid #808080',
      },
    },
    textButton: {
      color: ColorsV2.acent,
      backgroundColor: 'inherit',
      padding: 0,
      boxShadow: 'none',
      borderBottom: `2px solid transparent`,
      cursor: 'pointer',
      '&:hover': {
        borderBottom: `2px solid ${ColorsV2.acent}`,
      },
      '&:disabled': {
        color: '#808080',
      },
    },
    textFieldLowPriority: {
      backgroundColor: ColorsV2.primary,
      color: ColorsV2.white,
      borderRadius: "4px",
      width: 'fit-content',
    
      "& .MuiInputBase-root": {
        height: "40px",
        width: "275px",
        border: "solid 2px transparent",
        transition: "border-color 0.3s ease-in-out"
      },
    
      "& .MuiInputBase-input": {
        color: ColorsV2.white,
      },
    
      // Disable hover styling
      "&:hover .MuiInputBase-root": {
        borderColor: ColorsV2.acent,
      },
    
      // Disable focus border styling
      "& .MuiInputBase-root.Mui-focused": {
        borderColor: "transparent",
        boxShadow: "none",
      },
    
      // Specifically target the outlined variant's default focus effect
      "& .MuiOutlinedInput-notchedOutline": {
        border: "none", // Removes default outline border
      },
    
      "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: "none", // Ensures no border when focused
      },
      "& .MuiOutlinedInput-root.Mui-focused": {
        border: "2px solid " + ColorsV2.acent, // Ensures no border when focused
      },
    },
    textFieldMultiline: {
      backgroundColor: ColorsV2.primary,
      color: ColorsV2.white,
      borderRadius: "4px",
      width: 'fit-content',
    
      "& .MuiInputBase-root": {
        width: "275px",
        minHeight: "80px",
        border: "solid 2px transparent",
        transition: "border-color 0.3s ease-in-out",
        padding: "8px",
        alignItems: "start",
      },
    
      "& .MuiInputBase-input": {
        color: ColorsV2.white,
        resize: "vertical",
      },
    
      "&:hover .MuiInputBase-root": {
        borderColor: ColorsV2.acent,
      },
    
      "& .MuiInputBase-root.Mui-focused": {
        borderColor: "transparent",
        boxShadow: "none",
      },
    
      "& .MuiOutlinedInput-notchedOutline": {
        border: "none",
      },
    
      "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: "none",
      },
    
      "& .MuiOutlinedInput-root.Mui-focused": {
        border: "2px solid " + ColorsV2.acent,
      },
    },
    selectLowPriority: {
      minWidth: '150px',
      height: '40px',
      backgroundColor: ColorsV2.primary,
      borderRadius: '4px',
      color: ColorsV2.white, 
      '& .MuiOutlinedInput-notchedOutline': {
          transition: "border-color 0.3s ease-in-out",
          borderColor: ColorsV2.primary,
          borderWidth: '2px',
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: ColorsV2.acent,
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: ColorsV2.acent,
          borderWidth: '2px',
      },
      '& .MuiSelect-select': {
          padding: '10px',
          display: 'flex',
          alignItems: 'center',
      },
      '& .MuiSvgIcon-root': {
          color: ColorsV2.white,
      },
    }    
  },
};

const WhiteSpace = {
  xs: '0.625rem',
  small: '1rem',
};

const Containers = {
  shadowSubtleAcent: {
    boxShadow: `${alpha(ColorsV2.acent, 0.15)} 0px 0px 0px 3px`,
    padding: '20px',
    borderRadius: '4px',
  }
}

export { Buttons, WhiteSpace, Containers };
